import { MoveCoord } from '../../../jscaip/MoveCoord';
export class ReversiMove extends MoveCoord {
    static encoder = MoveCoord.getEncoder(ReversiMove.of);
    static PASS = new ReversiMove(-1, -1);
    static of(coord) {
        return new ReversiMove(coord.x, coord.y);
    }
    toString() {
        return 'ReversiMove(' + this.coord.x + ', ' + this.coord.y + ')';
    }
}
